import { render, staticRenderFns } from "./SuperTable.vue?vue&type=template&id=12607c0e"
import script from "./SuperTable.vue?vue&type=script&lang=js"
export * from "./SuperTable.vue?vue&type=script&lang=js"
import style0 from "./SuperTable.vue?vue&type=style&index=0&id=12607c0e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports